(function() {
    var $changeInputModeToggle = $('.J_changeInputMode');
    var $inputBox = $('.input-box');

    $changeInputModeToggle.on('click', function() {
        var $me = $(this);
        var $parent = $me.parents('.input-box');
        $inputBox.addClass('show');
        $parent.removeClass('show');
    });
})();